import { atom, useRecoilState } from "recoil";

import Environment from "services/environment";

import RestApiCall from "interceptor/aeh";
import { API_FETCH_STATUS } from "constants/common";
import { appendPartyId } from "utils/partyIdUtils";

const env = Environment.getEnv();
const { LOADING, SUCCESS, ERROR } = API_FETCH_STATUS;

const fetchConfigAPI = ({ payload, headers }) => {
  const apiPayload = {
    method: "POST",
    url: "v1/fetch/configuration/data",
    baseURL: env.bffBaseUrl,
    config: { ivUser: env.ivUser },
    headers: { ...headers, "rbac-identifier": headers.lob },
    data: payload,
  };
  return RestApiCall.api(apiPayload);
};

const DATA_CONFIG_INITIAL_STATE = {
  state: null,
  contents: {
    headerConfig: null,
    lobConfig: null,
  },
};

const dataConfigAtom = atom({
  key: "dataConfig",
  default: { ...DATA_CONFIG_INITIAL_STATE },
});

const useDataConfig = () => {
  const [configState, setConfigState] = useRecoilState(dataConfigAtom);

  const setConfig = (updatedProperties) => {
    updateStateProperties({
      contents: {
        ...updatedProperties,
      },
    });
  };

  const updateStateProperties = (updatedProperties) => {
    setConfigState({
      state: updatedProperties.state ?? configState.state,
      contents: { ...configState.contents, ...updatedProperties.contents },
      error: updatedProperties.error,
    });
  };

  const fetchConfig = ({ lobDetails, partyId }) => {
    if (!lobDetails) {
      return;
    }
    const { key: lob, isPartySupportedLob } = lobDetails;

    if (isPartySupportedLob && !partyId) {
      return;
    }

    updateStateProperties({ state: LOADING });

    const payload = { widgetId: "dashboardConfigV2" };
    if (isPartySupportedLob) {
      payload.partyId = partyId;
    }

    return fetchConfigAPI({ payload, headers: { lob } })
      .then((res) => {
        if (res.data && !res.data.code) {
          const lobConfig = res.data.data.lobConfig.map((lobItem) => {
            lobItem.link = env[lobItem.urlKey];

            if (lobItem.subscribed) {
              lobItem.services = lobItem.services.map((service) => {
                service.link = appendPartyId(env[service.urlKey], lobItem.code, partyId);

                return service;
              });

              lobItem.shortCuts = lobItem.shortCuts.map((shortCut) => {
                if (shortCut.code === "accessDT") {
                  shortCut.link = env[shortCut.urlKey];
                  return shortCut;
                }
                shortCut.link = appendPartyId(env[shortCut.urlKey], lobItem.code, partyId);

                return shortCut;
              });
            }

            return lobItem;
          });

          updateStateProperties({ state: SUCCESS, contents: { ...res.data.data, lobConfig } });

          return { ...res.data.data, lobConfig };
        } else {
          throw new Error(res);
        }
      })
      .catch((err) => {
        updateStateProperties({ state: ERROR, error: err });
        console.error(err);
        return err;
      });
  };

  return {
    config: configState,
    fetchConfig,
    setConfig,
  };
};

export default useDataConfig;
